import { setLoading } from "redux/actions/app.actions";
import { openNotificationWithIcon } from "utils/Notification";
import { request } from "./verb.services";
import { getServerErrorString } from "utils/common";

export const getAllPointsValuePolicies = (showLoading = true, callback) => {
  return (dispatch) => {
    if (showLoading) dispatch(setLoading(true));
    return request("LoyaltyPointValuePolicies", "get", null, true, null)
      .then((res) => {
        return {
          status: "success",
          data: res.data,
        };
      })
      .catch((e) => {
        openNotificationWithIcon("error", "Error!", getServerErrorString(e));
      })
      .finally(() => {
        if (showLoading) dispatch(setLoading(false));
      });
  };
};

export const getPointsValuePolicy = (id, callback) => {
  return (dispatch) => {
    dispatch(setLoading(true));
    return request(`LoyaltyPointValuePolicies/${id}`, "get", null, true)
      .then((res) => {
        return { status: "success", data: res.data };
      })
      .catch((e) => {
        openNotificationWithIcon("error", "Error!", getServerErrorString(e));
      })
      .finally(() => {
        dispatch(setLoading(false));
      });
  };
};

export const createPointsValuePolicy = (values, callback) => {
  return (dispatch) => {
    dispatch(setLoading(true));
    return request(`LoyaltyPointValuePolicies`, "post", values, true)
      .then((res) => {
        openNotificationWithIcon(
          "success",
          "Success",
          "Points value policy created successfully"
        );
        callback?.();
        return { status: "success", data: res?.data };
      })
      .catch((e) => {
        openNotificationWithIcon("error", "Error!", getServerErrorString(e));
      })
      .finally(() => {
        dispatch(setLoading(false));
      });
  };
};

export const updatePointsValuePolicy = (id, data, callback) => {
  return (dispatch) => {
    dispatch(setLoading(true));
    return request(`LoyaltyPointValuePolicies/${id}`, "put", data, true)
      .then(() => {
        openNotificationWithIcon(
          "success",
          "Success",
          "Points value policy updated successfully"
        );
        callback?.();
        return {
          status: "success",
        };
      })
      .catch((e) => {
        openNotificationWithIcon("error", "Error!", getServerErrorString(e));
      })
      .finally(() => {
        dispatch(setLoading(false));
      });
  };
};
